import { FETCH_CLIENTS } from "./action.types";
import fetch from "./action.fetch";

export const fetchClients = () => 
    fetch({
        url: '/clients',
        actionType: FETCH_CLIENTS
});